import React from "react";
import { Helmet } from "react-helmet-async";
import { Card } from "react-bootstrap";

import SignIn from "../../components/auth/SignIn";

const SignInPage = () => (
  <React.Fragment>
    <Helmet title="Prijava" />
    <div className="text-center mt-4">
      <h2>
        <a className="text-muted" href="/">
          NoviOglasi.com
        </a>
      </h2>
    </div>

    <Card>
      <Card.Body>
        <div className="m-sm-3">
          <SignIn />
        </div>
      </Card.Body>
    </Card>
  </React.Fragment>
);

export default SignInPage;
